module.exports = __webpack_public_path__ + "static/img/syfl-5.09bf8d89.jpg";